import React from "react"
import { Layout } from "antd"

const { Footer } = Layout;

function Foot(props:any){
  return (
      <Footer style={{ textAlign: "center" }}>© 2025 Ryo Solutions</Footer>
  )
}

export default Foot